import { Arrow } from 'components/ArteelIcons'

export const ArrowLink = () => {
  return <Arrow sx={{ fontSize: 'inherit', lineHeight: '1.235', width: '0.65em', height: '0.65em', ml: 0.25 }} />
}
